import React from 'react';
import { useField } from 'formik';

import Editor from '@zimpel/common/components/Editor';
import type { Props as EditorProps } from '@zimpel/common/components/Editor';
import ErrorHint from '@zimpel/common/components/ErrorHint';

export type Props = { name: string } & Omit<EditorProps, 'onChange' | 'text' | 'errorMessage'>;

const FormikEditor: React.FC<Props> = ({ name, ...props }) => {
  const [field, meta, fieldHelpers] = useField(name);
  return (
    <>
      <Editor
        {...props}
        text={field.value}
        hasError={!!meta.error}
        {...field}
        onChange={(text: string): void => {
          fieldHelpers.setValue(text);
          fieldHelpers.setTouched(true);
        }}
      />
      { meta.error && <ErrorHint>{meta.error}</ErrorHint> }
    </>

  );
};

export default FormikEditor;
